module.exports = __webpack_public_path__ + "assets/img/ps-1-light.8e4aed3f.png";